import { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import { db } from "../firebase";
import { Link } from "react-router-dom";
import { FaBed, FaEnvelope, FaMapMarkerAlt, FaPhoneAlt, FaShieldAlt, FaUtensils, FaWifi } from "react-icons/fa";

function Home() {
  const [showModal, setShowModal] = useState(false);
  const [roomsData, setRoomsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const roomsRef = ref(db, "rooms");
    const unsubscribe = onValue(roomsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const formatted = Object.values(data).map((room) => {
          const images = room.images
            ? Object.values(room.images).map((img) =>
                typeof img === "string" ? img : img.url
              )
            : [];
          return {
            name: room.name,
            type: room.type,
            images,
          };
        });
        setRoomsData(formatted);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="w-full">

      {/* Hero Section */}
      <section
        className="relative bg-cover bg-center h-[80vh]"
        style={{ backgroundImage: `url(/images/logo/home1.webp)` }}
      >
        <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center text-center text-white px-4">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">
            Welcome to ShriJi Girls Hostel Indore
          </h1>
          <p className="text-lg md:text-2xl mb-6">
            Comfortable, Affordable, and Modern Living Spaces
          </p>

          <Link
            to="/booking"
            className="bg-gradient-to-r from-yellow-500 to-orange-600 text-white px-6 py-3 rounded-full font-semibold hover:from-yellow-600 hover:to-orange-700 transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl"
          >
            Book Your Stay
          </Link>

          {/* 🔥 SEO Internal Link */}
          <p className="mt-4 text-white text-lg">
            Looking for the{" "}
            <a
              href="/girls-hostel-bhanwarkua-indore"
              className="underline text-yellow-300 font-semibold"
            >
              best girls hostel in Bhanwarkua Indore
            </a>
            ? Explore our detailed page.
          </p>
        </div>
      </section>

      {/* Rooms Section */}
      <section className="py-12 bg-gray-100">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-2xl font-bold text-center mb-6">Our Rooms</h2>

          {loading ? (
            <p className="text-center text-gray-500 mt-10">Loading rooms...</p>
          ) : roomsData.length === 0 ? (
            <p className="text-center text-gray-500 mt-10">No rooms available.</p>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
              {roomsData.map((room, idx) => (
                <Link
                  key={idx}
                  to={`/rooms/${room.name}?type=${room.type}`}
                  className="relative bg-white rounded-lg shadow-md overflow-hidden hover:scale-105 transition-transform duration-300"
                >
                  {room.type === "Premium" && (
                    <span className="absolute top-2 left-2 bg-yellow-500 text-white px-2 py-1 text-xs font-bold rounded">
                      Premium
                    </span>
                  )}

                  <img
                    src={room.images[0] || "/images/rooms/placeholder.webp"}
                    alt={`${room.name}-Seater`}
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-4 text-center">
                    <h3 className="font-bold text-lg">
                      {room.name}{" "}
                      {room.type === "Premium" && "(Premium)"}
                    </h3>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-yellow-500 to-orange-600 text-center">
        <h2 className="text-3xl font-bold mb-4 text-black">
          Ready to Move In?
        </h2>
        <p className="text-lg mb-6 text-yellow-100">
          Book your hostel room today and start your journey with comfort.
        </p>

        <Link
          to="/booking"
          className="bg-black text-white px-8 py-3 rounded-full font-semibold hover:bg-gray-800 transition"
        >
          Book Now
        </Link>

        {/* 🔥 FIXED CONTACT */}
        <div className="mt-12 flex flex-col md:flex-row justify-center gap-10 text-white text-lg font-medium">

          <div className="flex gap-3 items-center">
            <FaPhoneAlt className="text-2xl text-yellow-200" />
            <span>+91 70497 47730</span>
          </div>

          <div className="flex items-center gap-2">
            <FaEnvelope className="text-xl text-yellow-200" />
            <span>shrijigirlhostel@gmail.com</span>
          </div>

          <div className="flex items-center gap-2">
            <FaMapMarkerAlt className="text-xl text-yellow-200" />
            <span>Ashok Nagar, Bhanwarkua Main Road, Indore</span>
          </div>

        </div>
      </section>

    </div>
  );
}

export default Home;
